var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12043 16.7766C0.752416 17.2723 1.51994 17.7493 2.13727 17.7441L17.051 17.619C17.5083 17.6151 18.2223 17.6541 18.0318 17.2383C17.9781 17.1212 17.8858 16.9703 17.7404 16.7766C16.9446 15.7166 15.6774 14.8652 15.6774 14.8652L15.5305 7.96798C15.5305 7.96798 15.4056 5.66363 13.806 4.5696C12.5782 3.72987 11.6266 3.35458 11.2506 3.22548C11.1477 3.19015 11.0756 3.0943 11.0756 2.98548V2.98548C11.0756 2.39367 10.9985 1.75774 10.5407 1.38271C10.2972 1.18323 9.96012 1.01569 9.50885 1.00106C9.13954 0.989081 8.83852 1.08026 8.59968 1.21023C7.98887 1.54262 7.86094 2.30853 7.86094 3.00393V3.00393C7.86094 3.1027 7.79796 3.18992 7.7047 3.22244C7.20999 3.39491 5.6603 3.98237 4.80492 4.84459C3.77763 5.8801 3.26433 6.94459 3.26433 7.96798C3.26433 8.99137 3.26433 14.8652 3.26433 14.8652C3.26433 14.8652 1.3914 16.4117 1.12043 16.7766V16.7766Z",
    stroke: "#D91F05",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 9.49353,
    cy: 20.6152,
    rx: 1.974,
    ry: 1.01508,
    stroke: "#D91F05",
    strokeWidth: 1.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2501fbef412f4728b3efc2d304436a34.svg";
export { ForwardRef as ReactComponent };